<template>
  <v-btn color="#2a2825" :loading="loading" @click.stop="toggleFavorite" icon>
    <img
      class="e2e-favorite-icon"
      :alt="getAltAttributeText()"
      :height="getFavoriteIconHeight()"
      :src="getFavoriteIcon()"
      :width="getFavoriteIconWidth()"
    />
  </v-btn>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FavoriteIcon",
  computed: {
    ...mapGetters("favorites", {
      productCodes: "upcs",
    }),
    favorite() {
      return this.productCodes && this.productCodes.includes(this.upc);
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    getAltAttributeText() {
      return this.favorite
        ? "heart button click to unfavorite"
        : "heart button click to favorite";
    },
    getFavoriteIcon() {
      return this.favorite
        ? this.mobile
          ? require("@/assets/favorites/mobile/favorite-active.svg")
          : require("@/assets/favorites/desktop/favorite-active.svg")
        : this.mobile
        ? require("@/assets/favorites/mobile/favorite-inactive.svg")
        : require("@/assets/favorites/desktop/favorite-inactive.svg");
    },
    getFavoriteIconHeight() {
      return this.mobile ? 21 : 26;
    },
    getFavoriteIconWidth() {
      return this.mobile ? 20 : 30;
    },
    async toggleFavorite() {
      this.loading = true;
      if (this.favorite) {
        await this.$store.dispatch("favorites/delete", this.upc);
        this.loading = false;
      } else {
        await this.$store.dispatch("favorites/add", this.upc);
        this.loading = false;
      }
    },
  },
  props: { mobile: Boolean, upc: String },
};
</script>
